import { Pipe, PipeTransform } from '@angular/core';
import { FixedPipe } from './fixedPipe';

@Pipe({
    name: 'fixedPercent',
    standalone: false
})
export class FixedPercentPipe implements PipeTransform {
    private fixedPipe: FixedPipe = new FixedPipe();
    public transform(value: any): any {
        const fixed = this.fixedPipe.transform(value);
        if (fixed) {
            return fixed + '%';
        }
        return null;
    }
}
